import { render } from "./cookiebanner.vue?vue&type=template&id=4bc2052f&scoped=true"
import script from "./cookiebanner.vue?vue&type=script&lang=js"
export * from "./cookiebanner.vue?vue&type=script&lang=js"

import "./cookiebanner.vue?vue&type=style&index=0&id=4bc2052f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc2052f"]])

export default __exports__